<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner> -->
  <!-- <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">  
    <p style="color:white">Please Wait. </p>  
    </ngx-spinner>   -->
    <ngx-spinner  bdColor="rgba(255,255,255,0.8)" color="#5A5A5A" size="default" type="ball-spin-clockwise">  
        <p style="color:#5A5A5A">Please Wait. </p>  
        </ngx-spinner>  
    <!-- <ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="Ball Grid Beat"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner> -->